import { render, staticRenderFns } from "./KkvTeaserCopy.vue?vue&type=template&id=122479c5"
import script from "./KkvTeaserCopy.vue?vue&type=script&lang=js"
export * from "./KkvTeaserCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports